import React from 'react';
import { Card, CardBody, Progress } from 'reactstrap';

const statuses = [
  { label: 'Pending', value: 75 },
  { label: 'Approved', value: 47 },
  { label: 'Authorised', value: 82 },
  { label: 'Received', value: 90 },
];

const OrderStatusProgress = () => (
  <Card className="h-100">
    <CardBody>
      <h5 className="mb-4">Return Summary</h5>
      <div className="d-flex flex-column gap-3">
        {statuses.map((status, idx) => (
          <div key={idx}>
            <div className="d-flex justify-content-between">
              <span>{status.label}</span>
              <span>{status.value}%</span>
            </div>
            <Progress
              value={status.value}
              color="primary"
              style={{ height: 8 }}
            />
          </div>
        ))}
      </div>
    </CardBody>
  </Card>
);

export default OrderStatusProgress;
